<div class="form-row">
  <div class="form-group col-md-4">
    <label>Reference</label>
    <select class='form-control' [class.is-invalid]='this.operation.referenceId === -1'
      (change)='this.operation.referenceId = +$event.target.value'>
      <option value='-1'>Select a reference</option>
      @for (item of this.references; track item) {
        <option [value]='item.id' [selected]='this.operation.referenceId === item.id'>{{ item.name }}</option>
      }
    </select>
  </div>
  <div class="form-group col-md-4">
    <label>{{ this.isTransfer() ? 'From Warehouse' : 'Warehouse' }}</label>
    <select class='form-control' [class.is-invalid]='this.warehouseId === -1'
      (change)='this.onWarehouseChanged($event.target.value)'>
      <option value='-1'>Select a warehouse</option>
      @for (item of this.warehouses; track item) {
        <option [value]='item.id' [selected]='this.warehouseId === item.id'>{{ item.name }}</option>
      }
    </select>
  </div>
  @if (this.isTransfer()) {
    <div class="form-group col-md-4">
      <label>To Warehouse</label>
      <select class='form-control' [class.is-invalid]='this.toWarehouseId === -1'
        (change)='this.onToWarehouseChanged($event.target.value)'>
        <option value='-1'>Select a warehouse</option>
        @for (item of this.warehouses; track item) {
          <option [value]='item.id' [selected]='this.toWarehouseId === item.id'>{{ item.name }}</option>
        }
      </select>
    </div>
  }
</div>

<h3>Lines</h3>

@if (this.isAdjustment()) {
}

<!-- Says what the batch column is for and, just as importantly, what it is not. Batch tracking
     enforces nothing: a batch is recorded on the ledger row and consulted by no check, so this
     column changes what can be traced afterwards and never what may be posted. -->
<p class='text-muted'>

  @if (this.isTransfer()) {
  }

</p>

<!-- Same job as the batch paragraph above, and the same warning against reading a control into a
     recorded field. A weight is checked against nothing: not against the quantity on the line, not
     against a product weight, and not against the other reading in its own pair. In particular an
     end weight below the start weight is correct on anything going out, so it is accepted and
     flagged nowhere — the copy has to say so, or the first operator to see it will report it. -->
<p class='text-muted'>
  
  @if (this.isTransfer()) {
  }

</p>

<table class='table'>
  <thead>
    <th>Product</th>
    <th>Batch</th>
    <th>{{ this.isTransfer() ? 'From Location' : 'Location' }}</th>
    @if (this.isTransfer()) {
      <th>To Location</th>
    }
    <th>Qty</th>
    <!-- Three columns for two fields: the net is the readings' whole point, and computing it in the
         reader's head is what the reports exist to stop. Unlabelled by unit — weights are recorded
         in the site's own weight unit and there is no per-row unit to print. -->
    <th>Start Weight</th>
    <th>End Weight</th>
    <th>Net</th>
    <th></th>
  </thead>
  <tbody>
    <!-- lines already added -->
    @for (line of this.operation.lines; track line; let i = $index) {
      <tr>
        <td>{{ this.getProductName(line.productId) }}</td>
        <!-- Blank where the line carries no batch. An en dash or "none" would read as a value the
             operator chose against a field that was simply left alone. -->
        <td>{{ this.getBatchNumber(line) }}</td>
        <td>{{ this.getLocationName(line.warehouseLocationId) }}</td>
        @if (this.isTransfer()) {
          <td>{{ this.getLocationName(line.toWarehouseLocationId, true) }}</td>
        }
        <td>{{ line.qty }}</td>
        <!-- Blank where the line was not weighed, for the same reason the batch cell is blank, and
             blank on the net wherever either reading is missing. A 0 here would be a measurement
             nobody took, and zero is not available to mean "none" because an empty container on a
             tared scale really does weigh nothing. -->
        <td>{{ this.getStartWeight(line) }}</td>
        <td>{{ this.getEndWeight(line) }}</td>
        <td>{{ this.getNetWeight(line) }}</td>
        <td>
          <button class='btn btn-danger' type="button" (click)='this.deleteLine(i)'><i class="fas fa-trash"></i></button>
        </td>
      </tr>
    }

    <!-- new line -->
    <tr>
      <td>
        <select class='form-control'
          [class.is-invalid]='this.newLine.productId === -1'
          (change)='this.onLineProductChanged(this.newLine, $event.target.value)'>
          <option value='-1'>Select a product</option>
          @for (item of this.products; track item) {
            <option [selected]='this.newLine.productId === item.id' [value]='item.id'>{{ item.name }}</option>
          }
        </select>
      </td>
      <td>
        <!-- Free text with a datalist, NOT a select, and that is the whole point of this field.
             There is no batch table: a batch number comes into existence by being typed here at the
             moment the goods arrive. A pallet numbered for the first time has a number nothing has
             seen, so a closed list could not express it and would make the common case of a new
             delivery unpostable. The datalist suggests what this product has carried before and
             constrains nothing.

             Never marked invalid: an empty box is a legitimate answer and the only one most lines
             will use, so an is-invalid binding would turn an optional field into a required-looking
             one. Disabled until a product is chosen because the suggestions are per product, and
             because a number typed before the product is picked would be cleared by picking it.

             [value] bound, unlike the "Select a ..." dropdowns beside it. Without it the browser
             keeps showing the batch just used after a line is added and the model has been reset, so
             the next line would post with no batch while the box still read the old number. -->
        <input class='form-control' type='text' maxlength='64'
          placeholder='No batch number'
          [disabled]='this.newLine.productId === -1'
          [value]='this.getBatchNumber(this.newLine)'
          list='newLineBatchNumbers'
          (change)='this.onLineBatchNumberChanged(this.newLine, $event.target.value)'>
        <datalist id='newLineBatchNumbers'>
          @for (item of this.getBatchNumbersForProduct(this.newLine.productId); track item) {
            <option [value]='item'></option>
          }
        </datalist>
      </td>
      <!-- A box rather than a picker. The code is on the shelf label in front of the operator, so
           typing it beats finding it in a list of every location in the building - and the list only
           gets longer as the building fills up.

           The box holds TEXT and `warehouseLocationId` holds a resolved id or -1. Only the id is
           posted, so a code matching nothing cannot reach the ledger, and the backend's own check
           that the location exists is unchanged behind it. Nothing is guessed: an ambiguous code
           resolves to -1 rather than to whichever location matched first.

           `(input)` and not `(change)`, unlike the batch box above it, so the confirmation and the
           error appear while the code is being typed rather than only once the field is left. An
           operator needs to know they have the right shelf before they walk to it.

           [value] bound for the same reason the batch box is: after a line is added the model resets,
           and without it the browser keeps showing the code just used while the new line carries no
           location at all. -->
      <td>
        <input class='form-control' type='text' maxlength='64'
          placeholder='Location code'
          [class.is-invalid]='this.newLine.warehouseLocationId === -1'
          [disabled]='this.warehouseId === -1'
          [value]='this.locationText'
          (input)='this.onLocationTextChanged($event.target.value)'>
        @if (this.resolvedLocationLabel()) {
          <small class='text-success'>{{ this.resolvedLocationLabel() }}</small>
        }
        @if (this.locationError()) {
          <small class='text-danger'>{{ this.locationError() }}</small>
        }
      </td>
      @if (this.isTransfer()) {
        <td>
          <input class='form-control' type='text' maxlength='64'
            placeholder='Location code'
            [class.is-invalid]='this.newLine.toWarehouseLocationId === -1'
            [disabled]='this.toWarehouseId === -1'
            [value]='this.toLocationText'
            (input)='this.onLocationTextChanged($event.target.value, true)'>
          @if (this.resolvedLocationLabel(true)) {
            <small class='text-success'>{{ this.resolvedLocationLabel(true) }}</small>
          }
          @if (this.locationError(true)) {
            <small class='text-danger'>{{ this.locationError(true) }}</small>
          }
        </td>
      }
      <td>
        <input name='newqty' type='number' class='form-control'
          [class.is-invalid]='this.isQtyInvalid(this.newLine)'
          [(ngModel)]='this.newLine.qty'
          (blur)='this.onQtyChanged(this.newLine)' />
      </td>
      <!-- Never marked invalid, either of them. An empty box is a legitimate answer and the only one
           most lines will use, so an is-invalid binding would turn an optional field into a
           required-looking one — the same point the batch input above makes, and it applies harder
           here because there are two boxes and most lines leave both alone.

           No `min` and no `max`. A negative or an absurd reading is refused by the backend with a
           message the operator can act on; a native constraint here would claim a rule this screen
           does not own and would style the box against it before anything was posted. `step` is set
           because a weight is recorded to the gram and the default step of 1 would make 1250.125 a
           step mismatch in the browser.

           [value] bound rather than [(ngModel)], for both the reasons the batch input gives: the
           model maps a cleared box to null and ngModel would write '' or NaN straight past that, and
           without [value] the browser keeps showing the weights just used after a line is added and
           the model has been reset — so the next line would post unweighed while the boxes still
           read the last pallet's figures. -->
      <td>
        <input name='newstartweight' type='number' step='0.001' class='form-control'
          placeholder='Not weighed'
          [value]='this.getStartWeight(this.newLine)'
          (change)='this.onLineStartWeightChanged(this.newLine, $event.target.value)' />
      </td>
      <td>
        <input name='newendweight' type='number' step='0.001' class='form-control'
          placeholder='Not weighed'
          [value]='this.getEndWeight(this.newLine)'
          (change)='this.onLineEndWeightChanged(this.newLine, $event.target.value)' />
      </td>
      <!-- Read-only: the net is derived from the two boxes beside it and is never typed or posted. -->
      <td>{{ this.getNetWeight(this.newLine) }}</td>
      <td>
        <button class='btn btn-success' type='button' (click)='this.addLine()'><i class="fas fa-plus"></i></button>
      </td>
    </tr>
  </tbody>
</table>
